import * as React from 'react'
import {
  Typography,
  TextField,
  Grid,
  Box,
  InputAdornment,
  IconButton,
} from '@mui/material'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { PASSWORD_REGEX, EMAIL_REGEX } from 'helpers/constants'
import { Visibility, VisibilityOff } from '@mui/icons-material'
interface ExternalProps {
  control: any
  getValues: any
  resetField: any
}

function Step1(props: ExternalProps) {
  const { control } = props

  const { t } = useTranslation()

  const [showPassword, setShowPassword] = React.useState(false)

  const handleShowPassword = () => {
    setShowPassword((old) => !old)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        px: { xs: 2, sm: 2, md: 3, lg: 4, xl: 6 },
        pt: 2,
        pb: 4,
        borderRadius: 2.5,
        maxWidth: (theme) => theme.breakpoints.values.lg,
        mx: 'auto',
      }}
    >
      <Grid container rowSpacing={4}>
        <Grid item xs={12}>
          <Typography variant="body2" align="center">
            {t('dashboard.pages.createAgent.user.labelForUser')}
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <Controller
                rules={{
                  required: t('validation.fieldRequired') as unknown as string,
                  pattern: {
                    value: EMAIL_REGEX,
                    message: t(
                      'validation.emailPatternError' as unknown as string
                    ),
                  },
                }}
                name="user.username"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    fullWidth
                    variant="outlined"
                    label={`${t(
                      'dashboard.pages.createAgent.user.fields.username'
                    )}*`}
                    error={!!error}
                    helperText={error ? error?.message : ' '}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Controller
                rules={{
                  required: t('validation.fieldRequired') as unknown as string,
                  pattern: {
                    value: PASSWORD_REGEX,
                    message: t(
                      'validation.passwordPatternError'
                    ) as unknown as string,
                  },
                }}
                name="user.password"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={showPassword ? 'text' : 'password'}
                    label={`${t(
                      'dashboard.pages.createAgent.user.fields.password'
                    )}*`}
                    error={!!error}
                    helperText={error ? error?.message : ' '}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            color={showPassword ? 'primary' : 'secondary'}
                            onClick={handleShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Controller
                  name={`user.person.firstName`}
                  rules={{
                    required: false,
                  }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      fullWidth
                      variant="outlined"
                      label={`${t(
                        'dashboard.pages.createAgent.user.fields.firstName'
                      )}`}
                      error={!!error}
                      helperText={error ? error?.message : ' '}
                      {...field}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name={`user.person.lastName`}
                  rules={{
                    required: false,
                  }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      fullWidth
                      variant="outlined"
                      label={`${t(
                        'dashboard.pages.createAgent.user.fields.lastName'
                      )}`}
                      error={!!error}
                      helperText={error ? error?.message : ' '}
                      {...field}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default React.memo(Step1)
